import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Outlet,
  useLocation,
  useNavigate,
  Route,
} from 'react-router-dom';
import './App.css';
import AkakshiLanding from './components/home/Home';
import Login from './components/auth/Login';
import Logout from './components/auth/Logout';
import Signup from './components/auth/Signup';
import Dashboard from './components/dashboard/dashboard';
import Layout from './components/layout/Layout';
import DataSourceMangement from './components/MasterReports/DataSourceMangement';
import UserMasterReports from './components/MasterReports/UserMasterReports';
import Common from './components/MasterReports/Common';
import { setFindUserByIdUser } from './redux-toolkit/slices/allUserSlice';
import { useAppDispatch, useAppSelector } from './redux-toolkit/hooks';
import { getLocalStorageData } from './utils/LocalStorageService';
import { useGetUserByIdMutation } from './redux-toolkit/services/allUserService';
import { getAuthData } from './redux-toolkit/slices/authSlice';
import MemberAccountingReports from './components/MasterReports/MemberAccountingReports';
import VoucherTransactionReports from './components/MasterReports/VoucherTransactionReports';
import OpeningBalanceReports from './components/MasterReports/OpeningBalanceReports';
import InventoryReports from './components/MasterReports/InventoryReports';
import AuditLoggingReports from './components/MasterReports/AuditLoggingReports';
import AccountLedger from './components/accountLedger/accountLedger';

function App() {

  const localUserObj = getLocalStorageData("localUser");
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [findUserById, findUserByIdResponse] = useGetUserByIdMutation();

  const authUserData = useAppSelector(getAuthData);

  useEffect(() => {
    if (localUserObj) {
      findUserById({
        id: localUserObj.id,
        token: localUserObj.token
      });
    }
  }, [authUserData]);

  useEffect(() => {
    if (findUserByIdResponse.isSuccess) {
      localStorage.setItem("routeTo", "dashboard");
      dispatch(setFindUserByIdUser(findUserByIdResponse));
    }
  }, [findUserByIdResponse.isSuccess]);

  useEffect(() => {
    if (localUserObj) {
      if (findUserByIdResponse.isSuccess) {
        if (location.pathname === "/login") {
          navigate("/dashboard");

        } else {
          navigate(location.pathname);
        }
      } else if (location.pathname === "/") {
        navigate("/login");
      }
    } else {
      navigate("/login", { replace: true });
    }
  }, [findUserByIdResponse.isSuccess, authUserData]);


  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<AkakshiLanding />} />
        <Route path="/dashboard" element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
           <Route path="/account-ledger" element={<Layout />}>
          <Route path="/account-ledger" element={<AccountLedger />} />
        </Route>
        <Route path="/" element={<Layout />}>
          <Route path="data-source" element={<Outlet />}>
            <Route path=":reportType" element={<DataSourceMangement />} />
          </Route>
          <Route path="user-master" element={<Outlet />}>
            <Route path=":reportType" element={<UserMasterReports />} />
          </Route>
          <Route path="common" element={<Outlet />}>
            <Route path=":reportType" element={<Common />} />
          </Route>
          <Route path="accounting-masters" element={<Outlet />}>
            <Route path=":reportType" element={<MemberAccountingReports />} />
          </Route>
          <Route path="member-masters" element={<Outlet />}>
            <Route path=":reportType" element={<MemberAccountingReports />} />
          </Route>
          <Route path="scenario-scripture-masters" element={<Outlet />}>
            <Route path=":reportType" element={<MemberAccountingReports />} />
          </Route>
          <Route path="/voucher-transaction" element={<Outlet />}>
            <Route path=":reportType" element={<VoucherTransactionReports />} />
          </Route>
          <Route path="/opening-balances" element={<Outlet />}>
            <Route path=":reportType" element={<OpeningBalanceReports />} />
          </Route>
          <Route path="/inventory" element={<Outlet />}>
            <Route path=":reportType" element={<InventoryReports />} />
          </Route>
          <Route path="/audit-logging" element={<Outlet />}>
            <Route path=":reportType" element={<AuditLoggingReports />} />
          </Route>
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
    </div>
  );
}

export default App;
